import React from 'react';

const Bone = ({ className = '' }) => (
  <div className={`bg-stone-200/90 rounded-md ${className}`} />
);

/**
 * Checkout loading placeholder — mirrors mobile-first layout so the footer
 * doesn't jump up while event/payment data loads.
 */
const CheckoutSkeleton = () => (
  <div
    className="max-w-6xl mx-auto px-4 py-4 sm:py-8 lg:py-12 w-full animate-pulse"
    aria-busy="true"
    aria-label="Loading checkout"
  >
    <div className="mb-4 sm:mb-8 space-y-2">
      <Bone className="h-5 w-28 rounded-full" />
      <Bone className="h-8 sm:h-10 w-48 sm:w-64" />
      <Bone className="h-4 w-full max-w-md" />
      <Bone className="h-3 w-2/3 max-w-sm" />
    </div>

    <div className="grid grid-cols-1 lg:grid-cols-3 gap-4 lg:gap-8">
      <div className="lg:col-span-2 space-y-3 sm:space-y-5 order-1">
        {/* Mobile order strip */}
        <div className="lg:hidden flex items-center gap-3 rounded-xl border border-stone-200/80 bg-white px-3 py-2.5">
          <Bone className="w-11 h-11 rounded-lg shrink-0" />
          <div className="flex-1 space-y-2 min-w-0">
            <Bone className="h-4 w-3/4" />
            <Bone className="h-3 w-1/2" />
          </div>
          <div className="space-y-1.5 shrink-0">
            <Bone className="h-2.5 w-8 ml-auto" />
            <Bone className="h-4 w-14" />
          </div>
        </div>

        {/* Stepper */}
        <div className="rounded-xl border border-stone-200/80 bg-white px-2.5 py-2.5">
          <div className="flex items-center gap-2">
            <Bone className="w-6 h-6 rounded-full shrink-0" />
            <Bone className="h-3 w-16 sm:w-20" />
            <Bone className="h-px flex-1" />
            <Bone className="w-6 h-6 rounded-full shrink-0" />
            <Bone className="h-3 w-12 sm:w-14" />
            <Bone className="h-px flex-1" />
            <Bone className="w-6 h-6 rounded-full shrink-0" />
            <Bone className="h-3 w-14 sm:w-16" />
          </div>
        </div>

        {/* Form card */}
        <div className="bg-white rounded-2xl border border-stone-200/80 shadow-sm p-4 sm:p-6 lg:p-8 space-y-4">
          <div className="space-y-2 mb-2">
            <Bone className="h-5 w-44" />
            <Bone className="h-3 w-56" />
          </div>
          <div className="grid grid-cols-2 gap-3">
            <div className="space-y-1.5">
              <Bone className="h-3 w-16" />
              <Bone className="h-10 w-full rounded-lg" />
            </div>
            <div className="space-y-1.5">
              <Bone className="h-3 w-16" />
              <Bone className="h-10 w-full rounded-lg" />
            </div>
          </div>
          <div className="space-y-1.5">
            <Bone className="h-3 w-12" />
            <Bone className="h-10 w-full rounded-lg" />
          </div>
          <div className="space-y-1.5">
            <Bone className="h-3 w-12" />
            <Bone className="h-10 w-full rounded-lg" />
          </div>
          <Bone className="h-11 w-full rounded-xl mt-2" />
        </div>
      </div>

      {/* Desktop sidebar */}
      <div className="hidden lg:block lg:col-span-1 order-2">
        <div className="bg-white rounded-2xl border border-stone-200/80 shadow-sm p-6 space-y-4">
          <Bone className="h-5 w-28" />
          <div className="flex gap-4 pb-4 border-b border-stone-100">
            <Bone className="w-20 h-20 rounded-xl shrink-0" />
            <div className="flex-1 space-y-2 pt-1">
              <Bone className="h-4 w-full" />
              <Bone className="h-3 w-2/3" />
              <Bone className="h-3 w-1/2" />
            </div>
          </div>
          <Bone className="h-4 w-full" />
          <Bone className="h-4 w-3/4" />
          <div className="flex justify-between pt-3 border-t border-stone-100">
            <Bone className="h-5 w-14" />
            <Bone className="h-6 w-20" />
          </div>
        </div>
      </div>
    </div>
  </div>
);

export default CheckoutSkeleton;
